module.exports = __webpack_public_path__ + "img/icv.74289f38.png";